/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

export const convertToCamelCase = (key: string): string => {
  return key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
};

export const convertToSnakeCase = (key: string): string => {
  return key.replace(/([A-Z])/g, (letter) => `_${letter.toLowerCase()}`);
};

export const convertKeysCase = (
  data: any,
  type: 'snakeCase' | 'camelCase',
  dictionary?: Record<string, string>
): any => {
  const typeList = ['string', 'boolean', 'number'];
  const callback =
    type === 'camelCase' ? convertToCamelCase : convertToSnakeCase;

  if (Array.isArray(data)) {
    return data.map((element) => {
      if (typeList.includes(typeof element) || element === null) return element;

      if (typeof element === 'object') {
        return convertKeysCase(element, type, dictionary);
      }
      return element;
    });
  }

  if (data !== null && typeof data === 'object') {
    return Object.entries(data).reduce((acc, [key, value]) => {
      const newKey =
        dictionary && dictionary[key] ? dictionary[key] : callback(key);
      acc[newKey] =
        typeList.includes(typeof value) || value === null
          ? value
          : convertKeysCase(value, type, dictionary);
      return acc;
    }, {} as Record<string, unknown>);
  }

  return data;
};
